module.exports = __webpack_public_path__ + "static/34-80a31c630d11383aec0b48e075ef3083.png";